(function() {
const saved = localStorage.getItem("quiz_responses_v2");
if (!saved) {
  document.querySelector('.banner-quiz-result__saving').classList.add('hidden');
  return;
}
const {meal_split, pk_qty, saving} = JSON.parse(saved);
if (!meal_split || !pk_qty || !saving) {
  document.querySelector('.banner-quiz-result__saving').classList.add('hidden');
  return;
}

const savingMoney = document.querySelector('.saving-money');
const savingTime = document.querySelector('.saving-time');
const moneySaved = parseFloat(saving.moneySaved).toFixed(2);
const timeSaved = parseFloat(saving.timeSaved);

if (moneySaved < 5) {
  savingMoney.classList.add('hidden');
} 
if (timeSaved < 5) { 
  savingTime.classList.add('hidden');
}

const savingAmountYear = document.querySelector('.saving-amount');
const savingAmountMonth = document.querySelector('.saving-amount__month');
const savingAmountWeek = document.querySelector('.saving-amount__week');
const savingHours = document.querySelector('.saving-hours');

savingAmountWeek.textContent = `${formatMoney(moneySaved)}`;
savingAmountMonth.textContent = `${formatMoney(moneySaved * 4)}`;
savingAmountYear.textContent = `${formatMoney(moneySaved * 4 * 12)}`;
savingHours.textContent = `${timeSaved} min`;

function formatMoney(value) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(value);
}
})();
